import { Guide, StageStepsMap } from "./interfaces";
import { Modules, ModuleStageMap, Stages } from "../contracts";
import omit from "lodash/omit";
import difference from "lodash/difference";
import { onbordingStore } from "../store/index";

/**
 * Compute the static maps required for onboarding based on the type of user.
 * Example: For a user signing up from sales, the align module DO NOT have the vendor & resources exploration stage.
 * @returns OnboardingMaps
 *
 * @author Idrees
 */
const useOnboardingMaps = (): ((isResourcesEmpty: boolean) => void) => {
	const defaultStageSteps: Record<Stages, Guide[]> = { ...StageStepsMap };
	const defaultModuleStageMap: Record<Modules, Stages[]> = {
		...ModuleStageMap
	};

	const initializeMaps = (isResourcesEmpty: boolean) => {
		// remove last 2 stages if partner is not coming from vendor OR a align partner's vendor does not have any resources uploaded
		const { checkListBarData } = onbordingStore.getState();
		const isAlignUser =
			checkListBarData?.modules?.[0]?.name === Modules.ALIGN;
		if (!isAlignUser || isResourcesEmpty) {
			const stageSteps = omit(defaultStageSteps, [
				Stages.ALIGN_VENDORS_AND_RESOURCES,
				Stages.ALIGN_EXPLORE_RESOURCES
			]) as Record<Stages, Guide[]>;

			const alignModuleStages = defaultModuleStageMap[Modules.ALIGN];
			const updatedAlignModuleStages = difference(alignModuleStages, [
				Stages.ALIGN_VENDORS_AND_RESOURCES,
				Stages.ALIGN_EXPLORE_RESOURCES
			]);

			const lastStageinAlignModule =
				updatedAlignModuleStages[updatedAlignModuleStages.length - 1];
			if (lastStageinAlignModule) {
				const stepList = StageStepsMap[lastStageinAlignModule];
				const endStep = stepList.find(step => step.moduleComplete);
				if (endStep) {
					endStep.moduleComplete = false;
				}
				const lastStep = stepList[stepList.length - 1];
				lastStep.moduleComplete = true;
			}

			const moduleStages: Record<Modules, Stages[]> = {
				...defaultModuleStageMap,
				[Modules.ALIGN]: updatedAlignModuleStages
			};

			return { stageSteps, moduleStages };
		}

		return {
			stageSteps: defaultStageSteps,
			moduleStages: defaultModuleStageMap
		};
	};

	return initializeMaps;
};

export default useOnboardingMaps;
